import { Reveal } from "./Reveal";
import { track } from "../lib/analytics";
import { Link } from "react-router-dom";
import { SERVICES } from "../data/site";
import { ArrowUpRight } from "lucide-react";

const VISIBLE = SERVICES.filter((s) => !s.hidden);
const CTA_SPAN = { 0: "lg:col-span-3", 1: "lg:col-span-2", 2: "" }[VISIBLE.length % 3];

export default function Services({ onQuote }) {
  return (
    <section id="services" className="py-24 md:py-32 relative" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <Reveal>
            <p className="text-sm uppercase tracking-[0.25em] font-bold text-[#C85A40] mb-4">What I offer</p>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight text-[#1A1714] max-w-xl">
              Coverage for every chapter of life
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-[#4A453F] leading-relaxed">
              Because I'm independent, I compare plans across many carriers and bring you only the ones
              that fit your needs. Tap any card to read the guide.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {VISIBLE.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.06}>
              <Link
                to={`/guides/${s.guide}`}
                data-testid={`service-card-${s.num}`}
                onClick={() => track("guide_link_click", { guide: s.guide, location: "services" })}
                className="group block h-full bg-white rounded-2xl border border-[#D8D0C5] p-8 hover:border-[#C85A40] hover:shadow-[0_16px_40px_rgba(26,23,20,0.08)] transition-[border-color,box-shadow] duration-300"
              >
                <div className="flex items-start justify-between">
                  <span className="font-display text-5xl text-[#EAE3D9] group-hover:text-[#E8A365] transition-colors duration-300">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <ArrowUpRight className="w-5 h-5 text-[#C85A40] opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-300" />
                </div>
                <p className="mt-6 text-[11px] uppercase tracking-[0.2em] font-bold text-[#C85A40]">{s.tag}</p>
                <h3 className="mt-2 font-display text-2xl tracking-tight text-[#1A1714] group-hover:text-[#C85A40] transition-colors">{s.title}</h3>
                <p className="mt-3 text-[#4A453F] leading-relaxed">{s.desc}</p>
                <span className="mt-5 inline-flex items-center gap-1 text-[#1E3A2F] font-semibold text-sm">
                  Read the guide <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            </Reveal>
          ))}

          <Reveal delay={0.3} className={CTA_SPAN}>
            <button
              data-testid="services-cta"
              onClick={() => { track("book_a_chat_click", { location: "services" }); onQuote(); }}
              className="h-full w-full text-left bg-[#1E3A2F] rounded-2xl px-8 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-8 hover:bg-[#16302655] transition-colors duration-300"
            >
              <p className="font-display text-2xl text-[#F9F6F0] leading-snug">
                Not sure where to start? Let's talk it through, free.
              </p>
              <span className="inline-flex items-center gap-2 text-[#E8A365] font-semibold whitespace-nowrap shrink-0">
                Book a chat <ArrowUpRight className="w-5 h-5" />
              </span>
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
